import Vue from 'vue'

import FlagIcon from './FlagIcon'
import FlatIcon from './FlatIcon/FlatIcon'
import CloudImage from '../io/CloudImage'
import AtlasLoading from './AtlasLoading/AtlasLoading'
import DistanceUnit from './DistanceUnit'
import SystemInfo from './SystemInfo'

Vue.component('FlagIcon', FlagIcon)
Vue.component('FlatIcon', FlatIcon)
Vue.component('CloudImage', CloudImage)
Vue.component('AtlasLoading', AtlasLoading)
Vue.component('DistanceUnit', DistanceUnit)
Vue.component('SystemInfo', SystemInfo)
